import React, { FC, useContext } from 'react';
import { Box } from '@chakra-ui/react';
import InfolinoContext from '../../../context/InfolinoContext';
import useHotelGroupedData from '../../../hooks/useHotelGroupedData';
import TabTeaserGrid from '../../Common/TabTeaserGrid';

type InfolinoActivitiesProps = {};

const InfolinoActivities: FC<InfolinoActivitiesProps> = () => {
  const infolinoContext = useContext(InfolinoContext);

  const {
    groupedActivities,
    groupedActivitiesFreizeithotels,
  } = useHotelGroupedData(infolinoContext.hotel);

  return (
    <Box>
      <TabTeaserGrid
        subTitle={'Freizeit- & Aktivangebot'}
        tabs={groupedActivitiesFreizeithotels || []}
      />
    </Box>
  );
};

export default InfolinoActivities;
